<template>
  <button v-if="visible" class="magic-ui-button" @click="clickHandler">
    {{ config.text }}
  </button>
</template>

<script lang="ts" setup>
import { computed, getCurrentInstance, reactive } from 'vue';
import { MComponent } from '@tmagic/schema';

import useApp from '@/hooks/useApp';
import useDisplay from '@/hooks/useDisplay';
import initValue from '../initValue';

const props = defineProps<{
  config: MComponent & typeof initValue;
  model: Object;
}>();

useApp(props);
const vm = getCurrentInstance()?.proxy;
const actions = reactive<Function[]>([
  () => {
    if (props.config.link && props.config.link.startsWith('page:')) {
      // @ts-ignore
      window.appInstance.router.push(`/${props.config.link.slice(5)}`);
    } else if (props.config.link && (props.config.link as string).trim()) {
      window.location.href = props.config.link;
    }
  },
]);
const actualActions = computed(() => [
  typeof props.config.preAction === 'function'
    ? props.config.preAction
    : () => true,
  ...actions,
  typeof props.config.postAction === 'function'
    ? props.config.postAction
    : () => true,
]);
function pushAction(action: Function): void {
  actions.push(action);
}
async function clickHandler(): Promise<void> {
  for (const fn of actualActions.value) {
    if (typeof fn === 'function') {
      const ret = await fn(vm, { model: props.model });
      if (ret === false) {
        break;
      }
    }
  }
}
const { visible, show, hide } = useDisplay(props);
// 暴露给编辑器的接口请注册在这里
const exportInterface = reactive({
  pushAction,
  show,
  hide,
});

defineExpose(exportInterface);
</script>
